import { Button, toastFactory } from "@ttc3k/trekker";
import { useAppContext } from "core/components/apps/PreferredLayout";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Flex } from "styled-system/jsx";
import { useCreateAccomForm } from "./useCreateAccomForm";
import { AccomDetailsFormFields } from "./AccomDetailsFormFields";

export const CreateAccomForm = () => {
  const { setActionSection } = useAppContext();
  const { spaceId } = useParams();
  const navigate = useNavigate();

  const { form, onSubmit } = useCreateAccomForm({
    operatorID: spaceId ?? "",
    onSuccess: values => {
      const newPath = `/app/booker/${spaceId}/products/update-product/${values.productID}/product_info`;
      navigate(newPath);
      toastFactory.create({
        title: "Success!",
        description: `${values?.name} was created successfully`,
      });
    },
    onError: errorMsg => {
      toastFactory.create({
        title: "Error",
        description: errorMsg,
      });
    },
  });

  const formID = "create-accommodation-form";

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (form.formState.isDirty) {
        e.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [form.formState.isDirty]);

  useEffect(() => {
    setActionSection(
      <Flex gap={"150"}>
        <Button size={"lg"} form={formID} type={"submit"}>
          Save
        </Button>
      </Flex>,
    );
    return () => setActionSection(undefined);
  }, [setActionSection]);
  return (
    <FormProvider {...form}>
      <form id={formID} onSubmit={onSubmit}>
        <AccomDetailsFormFields />
      </form>
    </FormProvider>
  );
};
